import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { ProductDetailsBiList_productDetails_edges_node } from "../../types/ProductDetailsBiList";
import { ProductDetailsBiList } from "../ProductDetailsBiList";
import {
  createFilterStructure,
  ProductDetailsBiFilterKeys,
  ProductDetailsBiFilterOpts
} from "./filters";

export interface ProductDetailsBiPageProps
  extends ListProps,
    FilterPageProps<ProductDetailsBiFilterKeys, ProductDetailsBiFilterOpts>,
    TabPageProps {
  productDetails: ProductDetailsBiList_productDetails_edges_node[];
  onBack: () => void;
  download: () => void;
}

export const ProductDetailsBiPage: React.FC<ProductDetailsBiPageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  productDetails,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Product Details">
          <Button
            color="primary"
            variant="contained"
            disabled={!productDetails}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search by Category Name or Code"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />

          <ProductDetailsBiList
            productDetails={productDetails}
            {...listProps}
          />
        </Card>
      </Container>
    </>
  );
};

export default ProductDetailsBiPage;
